import type { LocationQuery } from 'vue-router'
import type { PeriodKind, PeriodSelection } from '@/api/snapshot'

const KINDS: PeriodKind[] = ['TODAY', 'LAST_7_DAYS', 'LAST_30_DAYS', 'CUSTOM']
const DAY = /^\d{4}-\d{2}-\d{2}$/
const text = (value: unknown): string | undefined => (typeof value === 'string' ? value : undefined)

/**
 * The review horizon a page keeps in its address (`?period=…&from=…&to=…`), so
 * a reload or a shared link keeps it. The last 7 days by default (P2 §4); the
 * Opportunities feed's is the last 30 (P3 §2.1).
 */
export const periodFromQuery = (query: LocationQuery, fallback: Exclude<PeriodKind, 'CUSTOM'> = 'LAST_7_DAYS'): PeriodSelection => {
  const period = text(query.period) as PeriodKind | undefined
  if (!period || !KINDS.includes(period)) return { period: fallback }
  if (period !== 'CUSTOM') return { period }
  const from = text(query.from)
  const to = text(query.to)
  return { period, from: from && DAY.test(from) ? from : undefined, to: to && DAY.test(to) ? to : undefined }
}

/** A chosen range without both ends is not asked for yet. */
export const isCompletePeriod = (selection: PeriodSelection): boolean =>
  selection.period !== 'CUSTOM' || (!!selection.from && !!selection.to)
